export enum OrderFilterEnum{
  DEFAULT = "default",
  LAST_CONTACT_ASC = "lastcontactasc",
  LAST_CONTACT_DESC = "lastcontactdesc",
  NAME = "name",
  NOTES_ADDED_DESC = "notesaddeddesc",
  PHONE_NUMBER = "phonenumber",
  BATTERY_DESC = "batterydesc"
}